//export const embededVideoUrl = "https://www.youtube.com/watch?v=3RqsFW6TmIk";
export const embededVideoUrl = "https://www.youtube.com/embed/3RqsFW6TmIk";
export const embededVideoUrl2 =
  "https://share.synthesia.io/embeds/videos/8ecd1566-0a17-4f09-8ecb-80cae38df94e";
//  "https://www.youtube.com/embed/7aemxGx7E9g?start=1";

export const contactNumber = "+263 71 080 7966";
export const whatsappNumber = "263710807966";

export const facebookLink = "https://www.facebook.com/totalurgenthealth";
export const instagramLink = "https://www.instagram.com/total.urgent.health";

export const mobileNavigationLinks = [
  {
    id: 0,
    title: "Home",
    exact: true,
    url: "/",
  },
  {
    id: 1,
    title: "Services",
    exact: true,
    url: "/#services",
  },
  {
    id: 2,
    title: "About",
    url: "/about-us",
    exact: true,
  },
  {
    id: 3,
    title: "Promotions",
    url: "/#promotions",
    exact: true,
  },
  {
    id: 4,
    title: "FAQ",
    url: "/#faqs",
    exact: true,
  },
  {
    id: 5,
    title: "Register For Free",
    url: "/register",
    exact: true,
  },
  {
    id: 6,
    title: "Sign In",
    url: "/login",
    exact: true,
  },
];

export const headersButtons = [
  { text: "home", link: "/" },
  { text: "services", link: "/#services" },
  { text: "about", link: "/about-us" },
  { text: "promotions", link: "/#promotions" },
  { text: "FAQ", link: "/#faqs" },
];
